

import NavSea from "../Components/NavSea"
import OffNavbar from "../Components/OfferNavbar"

function Navbar() {
    return <div className="bt" display='block'>
        <OffNavbar />
        <NavSea />
    </div>
}

export default Navbar